import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { useDestroyMaterializedProcess } from 'modules/processes/hooks/useDestroyMaterializedProcess'
import { categoryLabel } from 'modules/processes/lib/process'

type Props = {
  materializedProcessId: string
  onSuccess: () => void
  onClose: () => void
}

const RemoveMaterializedProcessModal = observer(
  ({ materializedProcessId, onSuccess, onClose }: Props) => {
    const { destroyMaterializedProcess } = useDestroyMaterializedProcess()

    const { performAction, running: deletingMaterializedProcess } = useAsyncAction(async () => {
      await destroyMaterializedProcess(materializedProcessId)

      onSuccess()
    })

    const { category } = useParams()
    const categoryName = categoryLabel(category || '')

    const modalTitle = i18n.t('processes.materialize_process.table.modals.remove.title', {
      category: categoryName,
    })

    const modalDescription = i18n.t(
      'processes.materialize_process.table.modals.remove.irreversible_warning'
    )

    const submitLabel = i18n.t('common.remove')

    return (
      <Modal
        illustration="alert"
        title={modalTitle}
        description={modalDescription}
        onSubmit={performAction}
        onClose={onClose}
        locked={deletingMaterializedProcess}
        footer={
          <>
            <Button disabled={deletingMaterializedProcess} type="secondary" onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>
            <Button disabled={deletingMaterializedProcess} submit>
              {submitLabel}
            </Button>
          </>
        }
      ></Modal>
    )
  }
)

const DeleteMaterializedProcessModalPage = () => {
  const { id, materializedProcessId } = useParams()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(-1)
  }

  if (!id) {
    onClose()
    return null
  }

  return (
    <RemoveMaterializedProcessModal
      materializedProcessId={String(materializedProcessId)}
      onClose={onClose}
      onSuccess={onClose}
    />
  )
}

export default DeleteMaterializedProcessModalPage
